import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
function AdminTicketDetail() {
  const {
    ticketId
  } = useParams();
  const navigate = useNavigate();
  const {
    request,
    showStatus
  } = useApi();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [newStatus, setNewStatus] = useState('');
  const messagesEndRef = useRef(null);
  const [ticketInfo, setTicketInfo] = useState(null);
  const [context, setContext] = useState(null);
  const [diagnostics, setDiagnostics] = useState(null);
  const [diagBusy, setDiagBusy] = useState(false);
  useEffect(() => {
    if (ticketId) {
      loadTicketInfo();
      loadMessages();
      setDiagnostics(null);
      request(`/api/v1/admin/support/tickets/${ticketId}/context`).then(setContext).catch(e => logger.error(e));
    }
  }, [ticketId]);
  const handleDiagnose = async () => {
    setDiagBusy(true);
    try {
      const data = await request(`/api/v1/admin/support/tickets/${ticketId}/diagnose`, {
        method: 'POST'
      });
      setDiagnostics(data?.checks || []);
    } catch (e) {
      showStatus('error', e?.message || 'Не удалось выполнить диагностику');
    } finally {
      setDiagBusy(false);
    }
  };
  const loadTicketInfo = async () => {
    try {
      const data = await request(`/api/v1/admin/support/tickets`);
      const current = data.find(t => t.id === ticketId);
      if (current) setTicketInfo(current);
    } catch (e) {
      logger.error(e);
    }
  };
  const handleUpdateTicket = async (field, value) => {
    try {
      await request(`/api/v1/admin/support/tickets/${ticketId}`, {
        method: 'PATCH',
        body: JSON.stringify({
          [field]: value
        })
      });
      showStatus('success', 'Обновлено');
      loadTicketInfo();
    } catch (e) {
      showStatus('error', 'Ошибка обновления');
    }
  };
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [messages]);
  const loadMessages = async () => {
    setLoading(true);
    try {
      const data = await request(`/api/v1/admin/support/tickets/${ticketId}/messages`);
      setMessages(data || []);
    } catch (error) {
      logger.error('Не удалось загрузить сообщения', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSendReply = async e => {
    e.preventDefault();
    if (!replyText.trim()) return;
    setSending(true);
    try {
      await request(`/api/v1/admin/support/tickets/${ticketId}/reply`, {
        method: 'POST',
        body: JSON.stringify({
          message: replyText,
          status: newStatus || null
        })
      });
      setReplyText('');
      setNewStatus('');
      showStatus('success', 'Ответ отправлен');
      await loadMessages();
    } catch (error) {
      logger.error('Ошибка отправки', error);
      showStatus('error', 'Не удалось отправить ответ');
    } finally {
      setSending(false);
    }
  };
  const formatTime = isoString => {
    const date = new Date(isoString);
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const handleConfirmReferralPayout = async () => {
    if (!window.confirm('Подтвердить списание средств со счёта?')) return;
    try {
      await request(`/api/v1/admin/support/tickets/${ticketId}/referral-confirm-payout`, {
        method: 'POST'
      });
      showStatus('success', 'Выплата подтверждена');
      await loadTicketInfo();
      await loadMessages();
    } catch (error) {
      logger.error('Ошибка при подтверждении выплаты', error);
      showStatus('error', 'Не удалось подтвердить выплату');
    }
  };
  return <div className="admin-page" style={{
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 100px)'
  }}>
            <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    }}>
                <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
      }}>
                    <button onClick={() => navigate('/admin/support')} style={{
          background: '#eee',
          border: 'none',
          padding: '10px 15px',
          borderRadius: '8px',
          cursor: 'pointer'
        }}>
            
                        ← Назад
                    </button>
                    <div>
                        <h1 style={{
            margin: 0,
            fontSize: '20px'
          }}>{ticketInfo?.subject || `Тикет #${ticketId?.slice(0, 8)}`}</h1>
                        <div style={{
            fontSize: '13px',
            color: '#666'
          }}>ID: {ticketId}</div>
                    </div>
                </div>
                {ticketInfo && <div style={{
        display: 'flex',
        gap: '10px'
      }}>
                        <select value={ticketInfo.priority} onChange={e => handleUpdateTicket('priority', e.target.value)} style={{
          padding: '8px',
          borderRadius: '6px',
          border: '1px solid #ddd'
        }}>

                            <option value="low">Низкий приор.</option>
                            <option value="normal">Обычный</option>
                            <option value="high">Высокий</option>
                            <option value="urgent">Критический</option>
                        </select>
                        <select value={ticketInfo.status} onChange={e => handleUpdateTicket('status', e.target.value)} style={{
          padding: '8px',
          borderRadius: '6px',
          border: '1px solid #ddd',
          fontWeight: 'bold'
        }}>

                            <option value="open">Открыт</option>
                            <option value="pending">В работе</option>
                            <option value="closed">Закрыт</option>
                        </select>
                        {ticketInfo.ticket_type === 'referral_withdrawal' && ticketInfo.status === 'open' && <button type="button" onClick={handleConfirmReferralPayout} style={{
          padding: '8px 16px',
          background: '#27ae60',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}>
                            Списание прошло
                        </button>}
                    </div>}
            </div>

            {context && <div style={{
      background: '#fff',
      border: '1px solid #e9ecef',
      borderRadius: '8px',
      padding: '12px 16px',
      marginBottom: '12px',
      fontSize: '13px',
      lineHeight: 1.6
    }}>
                    <div><b>Автор:</b> {context.author?.name || '—'} ({context.author?.email || '—'})</div>
                    {context.cabinet ? <>
                            <div><b>Кабинет:</b> {context.cabinet.name} · {context.cabinet.marketplace_type === 'ozon' ? 'Ozon' : 'Wildberries'}{context.cabinet.is_active ? '' : ' · отключён'}</div>
                            <div><b>Тариф:</b> {context.cabinet.plan_type}{context.cabinet.plan_trial_ends_at ? ` (пробный до ${context.cabinet.plan_trial_ends_at.slice(0, 10)})` : ''}{context.cabinet.ozon_subscription_tier ? ` · Ozon Premium-уровень: ${context.cabinet.ozon_subscription_tier}` : ''}</div>
                            <div><b>Доступ автора:</b> {context.cabinet.author_role || 'нет прямого доступа'}</div>
                            <div><b>Владелец:</b> {context.cabinet.owner?.email || '—'}</div>
                            <div><b>Управляющие:</b> {context.cabinet.managers.length ? context.cabinet.managers.map(m => `${m.email} (${m.role})`).join(', ') : '—'}</div>
                            <button type="button" onClick={handleDiagnose} disabled={diagBusy} style={{
          marginTop: '8px'
        }}>
                                {diagBusy ? 'Проверяю...' : 'Диагностика API кабинета'}
                            </button>
                            {diagnostics && <ul style={{
          margin: '8px 0 0',
          paddingLeft: '18px'
        }}>
                                    {diagnostics.map(c => <li key={c.key} style={{
            color: c.ok === false ? '#c0392b' : c.ok ? '#1e8449' : '#666'
          }}>
                                            {c.ok === false ? '✗' : c.ok ? '✓' : '—'} <b>{c.label}:</b> {c.message}
                                        </li>)}
                                </ul>}
                        </> : <div><b>Кабинет:</b> не указан</div>}
                </div>}

            <div style={{
      flex: 1,
      background: '#f0f2f5',
      borderRadius: '8px',
      padding: '20px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }}>
                {loading && <div style={{
        textAlign: 'center',
        color: '#666'
      }}>Загрузка...</div>}

                {messages.map(msg => {
        const isStaff = msg.is_staff;
        const initial = (msg.author_name || '?')[0].toUpperCase();
        return <div key={msg.id} style={{
          display: 'flex',
          flexDirection: isStaff ? 'row-reverse' : 'row',
          alignItems: 'flex-end',
          gap: '8px'
        }}>
              
                            {/* Avatar */}
                            <div style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            background: isStaff ? '#2980b9' : '#7f8c8d',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            fontWeight: 700,
            flexShrink: 0
          }}>
                                {initial}
                            </div>

                            {/* Bubble */}
                            <div style={{
            maxWidth: '65%'
          }}>
                                <div style={{
              fontSize: '12px',
              color: '#888',
              marginBottom: '3px',
              textAlign: isStaff ? 'right' : 'left',
              fontWeight: 600
            }}>
                                    {isStaff ? '🛡 Поддержка' : '👤 Клиент'} · {msg.author_name} · {formatTime(msg.created_at)}
                                </div>
                                <div style={{
              background: isStaff ? '#2980b9' : '#fff',
              color: isStaff ? '#fff' : '#1a1a2e',
              padding: '10px 14px',
              borderRadius: isStaff ? '16px 4px 16px 16px' : '4px 16px 16px 16px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
              whiteSpace: 'pre-wrap',
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
                                    {msg.body}
                                </div>
                            </div>
                        </div>;
      })}
                <div ref={messagesEndRef} />
            </div>

            <form onSubmit={handleSendReply} style={{
      marginTop: '20px',
      display: 'flex',
      gap: '10px',
      alignItems: 'flex-end'
    }}>
                <div style={{
        flex: 1
      }}>
                    <textarea value={replyText} onChange={e => setReplyText(e.target.value)} placeholder="Введите ответ..." disabled={sending} style={{
          width: '100%',
          minHeight: '80px',
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #ddd',
          resize: 'vertical',
          fontFamily: 'inherit'
        }} />
          
                </div>
                <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
                    <select value={newStatus} onChange={e => setNewStatus(e.target.value)} style={{
          padding: '8px',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }}>
            
                        <option value="">Не менять статус</option>
                        <option value="open">Открыт</option>
                        <option value="pending">В работе</option>
                        <option value="closed">Закрыт</option>
                    </select>
                    <button type="submit" disabled={sending || !replyText.trim()} style={{
          padding: '12px 24px',
          background: '#3498db',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: sending ? 'wait' : 'pointer',
          opacity: sending || !replyText.trim() ? 0.6 : 1
        }}>
            
                        {sending ? 'Отправка...' : 'Ответить'}
                    </button>
                </div>
            </form>
        </div>;
}
export default AdminTicketDetail;
